// libs
import React, { memo, useRef } from 'react';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';

// styles
import { TextLink } from './styles';

// helpers
import { generateTrackingUrl } from 'shared/components/AdPlatformWidgets/helpers';

// def
import { IWidgetItems } from 'shared/components/AdPlatformWidgets/types';

// hooks
import { useTrackingObserver } from 'shared/components/AdPlatformWidgets/ImpressionTracking/trackingHooks';
interface ITextProps {
  widgetItem: IWidgetItems;
  inventoryName: string;
  numOfColumns: number;
  contentAlign: string;
}

function Text({ widgetItem, inventoryName, numOfColumns, contentAlign }: ITextProps) {
  const title = widgetItem.parameters.title;

  const widgetRef = useRef<HTMLElement>(null);
  const trackingData = get(widgetItem, 'trackingData');
  useTrackingObserver({ widgetRef, trackingData });

  if (isEmpty(title)) return null;

  const actionUrl = generateTrackingUrl(
    widgetItem.parameters.web_action_url,
    inventoryName,
    widgetItem.positionInParent,
    widgetItem.parameters.tracking_parameters
  );

  return (
    <TextLink ref={widgetRef} href={actionUrl} numOfColumns={numOfColumns} align={contentAlign}>
      {title}
    </TextLink>
  );
}

export default memo(Text);
